<template>
  <AppScrollbar class="error-404" style="height: 100%">
    <div class="error-info clearfix">
      <div class="error-img"></div>
      <div class="button-group">
        <el-button type="primary" size="mini" plain v-if="$route.query.redirect" @click="refreshPage">刷新页面</el-button>
        <el-button type="warning" size="mini" plain @click="toHomePage">返回首页</el-button>
      </div>
    </div>
  </AppScrollbar>
</template>

<script>
import AppScrollbar from '../../elements/AppScrollbar'
export default {
  name: 'Error404',
  components: {AppScrollbar},
  props: {
    refresh: Boolean
  },
  methods: {
    // 刷新页面
    refreshPage () {
      this.$router.replace({ path: this.$route.query.redirect })
    },
    // 返回首页
    toHomePage () {
      this.$router.push({ path: '/' })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!from.matched || from.matched.length === 0) {
        // 首次打开
        vm.refreshPage()
      }
    })
  },
  watch: {
    refresh: function (val) {
      if (val) {
        this.refreshPage()
      }
    }
  }
}
</script>

<style lang="scss">
  .error-404 {
    background-color: #fff!important;
    .error-info {
      & > .error-img {
        margin: 5% auto 0;
        max-width: 100%;
        width: 600px;
        height: 360px;
        background: url("../../../assets/error/404.jpg") center no-repeat;
        background-size: cover;
      }
      & > .button-group {
        margin: 20px auto 50px;
        text-align: center;
        .el-button {
          padding: 5px 12px;
          border-radius: 0;
          & + .el-button {
            margin-left: 5px;
          }
        }
      }
    }
  }
</style>
